import { configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import lists, { type ListsState } from '@alltrails/lists/slices/lists';
import algoliaConfigs from '@alltrails/search/slices/algoliaConfigs';
import { AlgoliaConfigs } from '@alltrails/types/algoliaConfigs';
import type Context from '@alltrails/types/Context';
import { customRouteReducer as customRoute, CustomRouteState } from './customRoute';
import { mapReducer as map, MapState } from './reducer';

export type PreloadedState = {
  algoliaConfigs: AlgoliaConfigs;
  context: Context;
  lists: ListsState;
  map: MapState;
  customRoute: CustomRouteState;
};

export const reducer = {
  algoliaConfigs,
  context,
  lists,
  map,
  customRoute
};

export const buildStore = (preloadedState?: PreloadedState) => configureStore({ reducer, preloadedState });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

// these are intended to use within the package only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any) =>
  useSelector<RootState, any>(selector, shallowEqual);
